module.exports = __webpack_public_path__ + "img/skip-backward-fill.b222c093.svg";